const requestCountFormatter = Intl.NumberFormat("en-US", {
  notation: "compact",
});
const VersionHeader = ({
  number,
  counts,
}: {
  number: number;
  counts: { [index: number]: number };
}) => (
  <div className="mx-6 flex items-center justify-between">
    <div className="flex flex-shrink-0 flex-row items-center gap-x-1">
      <div className="text-start font-medium">{`Version ${number}`}</div>{" "}
      {counts[number] ? (
        <span className="rounded-full bg-gray-300 px-2 py-0.5 text-xs font-medium text-gray-800">
          {requestCountFormatter.format(counts[number])}
        </span>
      ) : null}
    </div>
  </div>
);

export default VersionHeader;
